import {getAPIVersion, getLanguage} from '../_shared/GWTBridge/invoke/common';
import {isDevEnv} from '../utils/platform';

const getMatchName = () => {
    return `${getAPIVersion()}_${getLanguage()}`;
};

export const getCachedData = (name: string) => {
    return (
        (!isDevEnv &&
            caches?.open(name).then(cachedResponse => {
                return cachedResponse.match(getMatchName()).then(response => {
                    if (!response || !response.ok) {
                        return false;
                    }

                    return response.json();
                });
            })) ||
        Promise.resolve()
    );
};

export const cacheData = async (name: string, data: any) => {
    !isDevEnv &&
        caches?.open(name).then(async cache => {
            // clean previus cache versions
            const keys = await cache.keys();
            for (let i = 0; i < keys.length; i++) {
                if (keys[i].url.indexOf(getMatchName()) === -1) {
                    cache.delete(keys[i].url);
                }
            }

            // add current cache version
            const response = new Response(JSON.stringify({...data, cached: true}), {
                headers: {
                    'content-type': 'application/json'
                }
            });

            cache.put(getMatchName(), response);
        });
};
